import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { ShowsDataService, ShowsColumnsService } from '../../../services';
import { Show, ShowsResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-show-form',
  templateUrl: './show-form.component.html',
  styleUrls: ['./show-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ShowFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public show: Show = {};
  public showForm: FormGroup = new FormGroup({});
  public shows: Show[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private showsDataService: ShowsDataService,
    public showsColumnsService: ShowsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'ShowFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Show - Edit');
        this.getShow(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.show !== 'undefined') {
      this.show = this.dynamicDialogConfig.data.show;
    }
    if (typeof this.show.id === 'undefined' || this.show.id === null) {
      this.show.id = null;
      this.show.isPublished = false;
    }
    this.getShows();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'ShowFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'ShowFormComponent');
  }

  getShow(id: number): void {
    this.isLoading = true;
    this.showsDataService.getShow(id).subscribe((response: Show|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.show = response;
        this.prepareFrom();
      }
    });
  }

  getShows(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.shows !== 'undefined' && this.dynamicDialogConfig.data.shows.length > 0) {
      this.shows = this.dynamicDialogConfig.data.shows;
      return;
    }
    this.showsDataService.getShows(this.parameters).subscribe((response: ShowsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.shows = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.showForm = new FormGroup({
      id: new FormControl(this.show.id, []),
      name: new FormControl(this.show.name, [Validators.required, ]),
      nameAr: new FormControl(this.show.nameAr, []),
      nameFr: new FormControl(this.show.nameFr, []),
      slug: new FormControl(this.show.slug, []),
      slugAr: new FormControl(this.show.slugAr, []),
      slugFr: new FormControl(this.show.slugFr, []),
      picture: new FormControl(this.show.picture, []),
      isPublished: new FormControl(this.show.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/shows']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.showForm.controls).forEach((field: any) => {
        const control = this.showForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.showForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.show = this.showForm.value;
    this.disableSubmit = true;
    console.log('show', this.show);
    if (typeof this.show.id !== 'undefined' && this.show.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.showsDataService.updateShow(this.show).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SHOWUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SHOWNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.showsDataService.addShow(this.show).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('SHOWCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('SHOWNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.showForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'shows',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.showForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-show-form',
  templateUrl: './show-form.component.html',
  styleUrls: ['./show-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogShowFormComponent extends ShowFormComponent {
}

